import tokenCss from "../an26-tokens.css";
import layoutCss from "./injectStyles.css";

const STYLE_ID = "nten-data-design-styles";
const STYLE_ID_LEGACY = "an26-data-design-styles";

/** Injected once — design tokens and layout for all NTEN embeds. */
export function ensureNtenDesignStyles(): void {
  if (typeof document === "undefined") return;
  if (document.getElementById(STYLE_ID) || document.getElementById(STYLE_ID_LEGACY)) return;
  const el = document.createElement("style");
  el.id = STYLE_ID;
  el.textContent =
    String(tokenCss) +
    "\n" +
    String(layoutCss);
  document.head.appendChild(el);
}

/**
 * @deprecated Use {@link ensureNtenDesignStyles} instead.
 */
export function ensureAn26DesignStyles(): void {
  ensureNtenDesignStyles();
}
